import { MotionProps } from 'framer-motion';

export const pageTransitionAnimationProps: MotionProps = {
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 1.2 },
  initial: { opacity: 0, scale: 0.7 },
};
